module.exports = __webpack_public_path__ + "static/media/jh233xa8.ca8f2fff.png";